<main *ngIf="userType == 'estate-agent'" class="main-container estate-agent">
    <div class="content">
        <div class="col-12 text-center">
            <div class="heading-1 mt-3">
                OPPORTUNITY FOR BROKERs/AGENTs
            </div>
        </div>
        <div class="col-12 mt-2 paragraph">
            <p>
                Welcome to <b>Property Matrix </b> – The platform where town planning insight unlocks
                potential others miss. We’re inviting top-performing brokers, agents, and
                agencies across South Africa to list smarter and sell faster!
            </p>
        </div>
        <div class="col-12 paragraph mt-4">
            <div class="heading-1">How to Get Started</div>
            <ul class="p-2 numbers-list">
                <li> Principal/Director register first and sign the digital contract - available for download on next
                    page.</li>
                <li>Create your log-in account.</li>
                <li>Watch 3-min introductory video</li>
                <li>Register: <b>Have these PDF documents ready</b> - the system doesn’t allow partial saving:</li>
                <ul class="sollid-bulets">
                    <li>Signed agreement (for principals)</li>
                    <li [hidden]="!isPrincipal">Compliant FFC – Company (for principals)</li>
                    <li [hidden]="isPrincipal">Compliant FFC – Individual</li>
                    <li>Copy of ID</li>
                    <li>Face-only photo (optional but recommended)</li>
                </ul>
                <li>Principal nominates agents to register</li>
                <li>Receive your Starter Kit – packed with tools to help you win exclusive mandates.</li>
                <li>Start listing and selling with confidence!</li>
            </ul>
        </div>
        <div class="row paragraph mt-5">
            <div class="text-center">
                <button class="button" type="button" (click)="proceed()">PROCEED</button>
            </div>
        </div>
    </div>
</main>
<main *ngIf="userType == 'urban-planner'" class="main-container urban-planner">
    <div class="content">
        <div class="col-12 text-center">
            <div class="heading-1 mt-3">
                OPPORTUNITY FOR SACPLAN-REGISTERED PLANNERS
            </div>
        </div>
        <div class="col-12 mt-4 paragraph">
            <p>
                Thank you for visiting our platform. <b>Property Matrix</b> is a national network of professional town
                planners, estate agents, property valuers, urban economists, bond originators, and conveyancers. Our
                operations cover Tshwane, Johannesburg, Ekurhuleni, Cape Town, and eThekwini.
            </p>
            <p>
                We facilitate connections between planners operating in these areas and clients in need of land use
                management (LUMS) expertise. Our process involves generating an initial planning report for a property,
                which is then sent to an 'associate planner.' This associate planner reviews, expands on, and approves
                the report.
            </p>
            <p>
                This report serves as a resource for <b>Property Matrix</b> clients, offering insights into the
                property's existing land use rights and, importantly, its development, expansion, or enhancement
                potential. The report also includes recommendations for necessary planning applications and estimated
                timeframes for realising this potential. We commit to directing all statutory planning tasks stemming
                from such a property report to the appropriate associate planner.
            </p>
            <p>
                To partner as an 'associate planner' with <b>Property Matrix</b>, you must be a SACPLAN registered
                professional town planner and hold a leadership role in an established consulting town planning firm,
                such as a director, partner, or senior planner.
            </p>
        </div>

        <div class="col-12 mt-4 paragraph">
            <div class="heading-5">
                Professional Details
            </div>
            <div class="sacplan-input-container row mt-2">
                <div class="col-3">
                    <label for="sacplan" class="sacplan-input-label">
                        Full SACPLAN registration number
                    </label>
                </div>
                <div class="col-7">
                    <input type="text" class="form-control sacplan-input placeholder-visible" id="sacplan"
                        name="sacplan" required [formControl]="sacplanRegistrationNumber" (input)="removeSpaces($event)"
                        (paste)="removeSpaces($event)" placeholder="A4566/1988" />
                    <div *ngIf="showSacplanError" class="sacplan-error-text">
                        <div *ngIf="sacplanRegistrationNumber.errors?.required">
                            SACPLAN registration number is required
                        </div>
                        <div *ngIf="sacplanRegistrationNumber.errors?.pattern">
                            Invalid SACPLAN registration number format
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 mt-4 paragraph">
            <span class="heading-5">
                Your SACPLAN registration type:
            </span>
            <mat-radio-group class="sacplan-registration-types mt-2">
                <mat-radio-button class="paragraph mt-1" *ngFor="let type of sacplanRegistrationTypes" [value]="type.id"
                    (change)="selectSacplanRegistrationType(type.id)">
                    {{ type.value }}
                </mat-radio-button>
            </mat-radio-group>
        </div>
        <div *ngIf="isProfessionalPlanner == false" class="col-12 mt-4 paragraph">
            <p>
                <b>Please note:</b> Only professional, senior planners - registered with SACPLAN - can
                partner with Property Matrix, and sign off on our planning reports.
            </p>
        </div>
        <div class="row paragraph mt-5">
            <div class="text-center">
                <button class="button" type="button" (click)="proceed()">PROCEED</button>
            </div>
        </div>
    </div>
</main>